export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_RESTAURANT = "UPDATE_RESTAURANT";
export const UPDATE_ATTRIBUTES = "UPDATE_ATTRIBUTES";
export const UPDATE_TOKENS = "UPDATE_TOKENS";
export const UPDATE_RESTAURANT_STATISTICS = "UPDATE_RESTAURANT_STATISTICS";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const UPDATE_USERS_STATISTICS = "UPDATE_USERS_STATISTICS";
export const UPDATE_FIRST_RESTAURANT = "UPDATE_FIRST_RESTAURANT";



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js